module.exports = __webpack_public_path__ + "img/wps-1.2b15d111.png";